import React from 'react';
import { RefreshCwIcon } from 'lucide-react';
import { CTAButton, CTAMicroCopy } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
const rows = [{
  label: 'Ruta Hipotiroidismo™ (6 Tomos Premium)',
  value: 'USD $97'
}, {
  label: '5 Bonos Exclusivos',
  value: 'USD $97'
}];
export function Offer() {
  return <section id="oferta" className="w-full bg-navy-50/60 px-4 py-14 sm:py-20" data-id="element-201" data-mp="3a5gpqlw4wsok">
      <div className="mx-auto w-full max-w-2xl" data-id="element-202" data-mp="3f4jsfzon6mtd">
        <h2 className="text-center font-display text-[26px] font-black leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-203" data-mp="3f38nvxndhb17">
          🏆 Oferta Especial de Lanzamiento
        </h2>

        <div className="mt-8 rounded-3xl border-2 border-accent bg-white p-5 shadow-xl shadow-navy-900/10 sm:p-8" data-id="element-204" data-mp="3nvshukspyrfp">
          <p className="text-center text-xs font-extrabold uppercase tracking-widest text-navy-700/70" data-id="element-205" data-mp="3sxhu23rohb5d">
            Todo lo que recibirás hoy
          </p>

          <dl className="mt-5 divide-y divide-navy-100" data-id="element-206" data-mp="1kl85ok7eit4z">
            {rows.map(row => <div key={row.label} className="flex items-start justify-between gap-4 py-3" data-id="element-207" data-mp="1fmn7eqbpmjj6">
                <dt className="text-[14px] font-semibold leading-snug text-navy-900 sm:text-base" data-id="element-208" data-mp="1bll7066241fm">
                  {row.label}
                </dt>
                <dd className="shrink-0 text-[14px] font-bold text-navy-700/70 sm:text-base" data-id="element-209" data-mp="23bya4dcmenzy">
                  {row.value}
                </dd>
              </div>)}
            <div className="flex items-center justify-between gap-4 py-3" data-id="element-210" data-mp="1zch3vhpddmtq">
              <dt className="text-[14px] font-extrabold uppercase tracking-wide text-navy-950 sm:text-base" data-id="element-211" data-mp="1ui35d6feuzku">
                Valor Total
              </dt>
              <dd className="shrink-0 text-lg font-black text-navy-400 line-through sm:text-xl" data-id="element-212" data-mp="2mzp0zccn9pko">
                USD $194
              </dd>
            </div>
          </dl>

          <div className="mt-6 rounded-2xl bg-navy-950 px-4 py-6 text-center" data-id="element-213" data-mp="2i7dz43ycftph">
            <p className="text-[13px] font-semibold uppercase tracking-widest text-navy-300" data-id="element-214" data-mp="316919jurtllw">
              Hoy puedes acceder por solo
            </p>
            <p className="mt-2 font-display text-5xl font-black leading-none text-white sm:text-6xl" data-id="element-215" data-mp="2sdp0acr0b4xw">
              USD $15
            </p>
            <p className="mx-auto mt-4 max-w-sm text-[13px] leading-relaxed text-navy-100/75 sm:text-sm" data-id="element-216" data-mp="2wd7kf6b07bzo">
              Menos de lo que cuesta una comida… para adquirir un sistema que
              puede acompañarte durante toda tu práctica profesional.
            </p>
          </div>

          <div className="mt-6" data-id="element-217" data-mp="29fmf691kxs5d">
            <CTAButton label="QUIERO LA RUTA HIPOTIROIDISMO AHORA" data-id="element-218" data-mp="29gdyakdzpxer" />
            <CountdownTimer data-id="element-219" data-mp="2dgo9cbgn3e0h" />
            <CTAMicroCopy text="Descarga inmediata · Pago único · Acceso de por vida · Garantía de 7 días" data-id="element-220" data-mp="2dhpu57ngjeve" />
          </div>

          <div className="mt-6" data-id="element-221" data-mp="bo9pv7yg61hy">
            <ScarcityBar data-id="element-222" data-mp="bn8f74lcfh0r" />
          </div>

          <div className="mt-5 flex items-start gap-3 rounded-2xl bg-navy-50 p-4" data-id="element-223" data-mp="bm71stguuifv">
            <RefreshCwIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-224" data-mp="1w4hlcn69iai3" />
            <p className="text-[13px] leading-relaxed text-navy-900 sm:text-sm" data-id="element-225" data-mp="25w3veg6v63j9">
              <span className="font-bold" data-id="element-226" data-mp="215nfmpfkm5tq">
                💳 Cambio de moneda automático.
              </span>{' '}
              Puedes pagar en la moneda de tu país: la conversión se realiza
              automáticamente al tipo de cambio vigente al momento de la compra.
            </p>
          </div>
        </div>
      </div>
    </section>;
}